import fetcher_v2 from "../fetcher_v2";
import { QueryOut } from "@/containers/QueryBuilderNew/requestUtils";
import { URLS } from "../urls";
import { ComponentErrors } from "@/types/ComponentErrors";
import { MentionCard } from "@/types/MentionCard";

export type PreviewResponse = {
  count: number;
  next: Nullable<string>;
  previous: Nullable<string>;
  page: number;
  page_count: number;
  estimated_mentions: number;
  results: MentionCard[];
};

type PreviewBody = {
  start_date: string | null;
  end_date: string | null;
  queries: QueryOut[];
  industry: string | null;
  page_size: number;
  page_token: number;
};

export const previewSearch = async (data: PreviewBody) => {
  return fetcher_v2<PreviewResponse, PreviewBody, ComponentErrors>(
    URLS.API_PREVIEW_RESULTS,
    {
      method: "POST",
      body: data,
    }
  );
};
